// extracted by mini-css-extract-plugin
export default {"spinner":"styles_spinner__1T4RI","load2":"styles_load2__keApW"};